import React, { useEffect, useState } from "react";
import "./style.css";
import PropTypes from "prop-types"; // Import PropTypes
import axios from "axios";
import env from "../../../../config/env"
import { useUserInfo } from "../../../../context/user";

function CompanyContent() {
  const BASE_URL = `${env.API_URL}/v1`;
  const user = useUserInfo()[0];
  const activeLocation = useUserInfo()[4];

  return (
    <div className="settingsPage">
      <form className="form-border">
        <h2
          style={{ marginBottom: "20px", fontSize: "20px", fontWeight: "bold" }}
        >
          Company Information
        </h2>
        <div className="form-row">
          <div className="form-group col-md-6">
            <label htmlFor="userName">Company Name</label>
            <input
              type="text"
              className="form-control"
              id="userName"
              name="userName"
              readOnly="true"
              disabled="true"
              defaultValue={activeLocation?.business_name}
            />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              readOnly="true"
              disabled="true"
              defaultValue={activeLocation?.email}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-6">
            <label htmlFor="contactNumber">Contact Number</label>
            <input
              type="text"
              className="form-control"
              id="contactNumber"
              name="contactNumber"
              readOnly="true"
              disabled="true"
              defaultValue={activeLocation?.phone_number}
            />
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="contactNumber">Address</label>
            <input
              type="text"
              className="form-control"
              id="contactNumber"
              name="contactNumber"
              readOnly="true"
              disabled="true"
              defaultValue={activeLocation?.address}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
export default CompanyContent;